'use client';

import { useState } from 'react';

interface WeekAccordionProps {
  /** "Week 1", "Week 2", etc. — already translated by the server component. */
  label: string;
  /** Week index (0-based), used to default the first week open. */
  index: number;
  /** Whether this week contains any scheduled events. */
  defaultOpen: boolean;
  children: React.ReactNode;
}

/**
 * Collapsible week toggle shown only on narrow screens (≤ 640 px).
 * The server component renders these; they hydrate on the client for the
 * open/close interaction. On wider screens the toggle header is hidden via
 * CSS and the children are always visible.
 */
export function WeekAccordion({ label, index, defaultOpen, children }: WeekAccordionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className={`cs-week-accordion${open ? ' is-open' : ''}`}>
      <button
        className="cs-week-toggle"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="cs-week-toggle-label">{label}</span>
        <svg
          className="cs-week-toggle-chevron"
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          aria-hidden="true"
        >
          <path d="M10.5 6.75L6 3.25L1.5 6.75" stroke="#F7F4F8" strokeLinecap="round" />
        </svg>
      </button>
      <div className="cs-week-accordion-body">{children}</div>
    </div>
  );
}
